import { EventType } from './EventType';
/**
 * Airship Preference Center.
 */
export class AirshipPreferenceCenter {
    constructor(plugin) {
        this.plugin = plugin;
    }
    /**
     * Requests to display a preference center.
     *
     * Will either emit an event to display the
     * Preference Center if auto launch is disabled,
     * or display the OOTB UI.
     * @param preferenceCenterId The preference center Id.
     * @returns A promise.
     */
    display(preferenceCenterId) {
        return this.plugin.perform('preferenceCenter#display', preferenceCenterId);
    }
    /**
     * Gets the preference center config.
     * @param preferenceCenterId The preference center Id.
     * @returns A promise with the result.
     */
    getConfig(preferenceCenterId) {
        return this.plugin.perform('preferenceCenter#getConfig', preferenceCenterId);
    }
    /**
     * Enables or disables showing the OOTB UI when requested to display by either
     * `display` or by a notification with some other action.
     * @param preferenceCenterId The preference center Id.
     * @param autoLaunch true to show OOTB UI, false to emit events.
     * @returns A promise with the result.
     */
    setAutoLaunchDefaultPreferenceCenter(preferenceCenterId, autoLaunch) {
        return this.plugin.perform('preferenceCenter#getConfig', [
            preferenceCenterId,
            autoLaunch,
        ]);
    }
    /**
     * Adds a display message center listener.
     */
    onDisplay(listener) {
        return this.plugin.addListener(EventType.DisplayPreferenceCenter, listener);
    }
}
//# sourceMappingURL=AirshipPreferenceCenter.js.map